import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const forceActiveMerchant = {
  namespaced: true,

  state() {
    return {
      flashErrorMessage: '',
      flashError: false,
      loading: false,
      allData: [],
      totalPage: 0,
      totalData: 0,
      errors: [],
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
    };
  },
  mutations: {
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },
    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setData(state, { payload }) {
      state.allData = payload.data.list;
    },
  },
  actions: {
    async fetchDataForceActiveMerchant(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, type }
    ) {
      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sortByData = '';
      if (sortBy[0] != null) {
        if (sortBy[0] == 'mid') {
          sortByData = `mid_static ${sort}`;
        } else {
          sortByData = `${sortBy[0]} ${sort}`;
        }
      } else {
        sortByData = `id ${sort}`;
      }

      const urlType = (typeUrl) => {
        const typeUrlDta =
          typeUrl == 'approval'
            ? 'request_list/approver-force/list'
            : 'onboarding/force-active/list';
        return typeUrlDta;
      };

      const data = JSON.stringify({
        search,
        sort_by: sortByData,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/${urlType(type)}`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
      ctx.commit('setLoading', false);
    },

    async bulk_confirm(ctx, { date, id, type }) {
      const remark = `Bulk Approve by ${
        JSON.parse(localStorage.getItem('logged_in_qram')).user.username
      }`;
      ctx.commit('setLoading', true);

      const urlConfirm = (typeData) => {
        switch (typeData) {
          case 'request':
            return 'onboarding/force-active/request-approve';
          case 'approve':
            return 'request_list/approver-force/approve';
          default:
            return 'request_list/approver-force/reject';
        }
      };

      const data = JSON.stringify({
        merchant_id: id,
        remark,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const config = {
        method: 'post',
        url: `${
          process.env.VUE_APP_API_BASE_URL
        }/index.php?r=api/v1/${urlConfirm(type)}`,
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => {
          if (response.data.code != '200') {
            if (localStorage.getItem('language_qram') == null) {
              ctx.commit('setFlashErrorMessage', response.data.message_id);
            } else {
              ctx.commit('setFlashErrorMessage', response.data.message_en);
            }

            if (response.data.code == '401') {
              ctx.dispatch('logout', null, { root: true });
            }

            return false;
          }
          return true;
        })
        .catch((error) => {
          if (error.response.data.code != null) {
            if (error.response.data.code == '401') {
              ctx.dispatch('logout', null, { root: true });
            }
          }
          return false;
        })
        .finally(() => {
          ctx.commit('setLoading', false);
        });
    },
  },
};

export default forceActiveMerchant;
